/*
 * Created by alex@hackerbay.com on 24.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import {STAGES} from "./pages/Stage";
import moment from "moment";
import technicianAppointmentRequired from "./technicianRequired";

const DEBUG = true;

function getDaysUntilAppointment(appointmentDate){
    function normalizeMoment(date){
        return date.set("hours", 0).set("minutes", 0).set("seconds", 0).set("milliseconds", 0);
    }
    return normalizeMoment(moment(appointmentDate)).diff(normalizeMoment(moment()), "days");
}


/**
 * Helps determine CC stage entry points and next stage
 * An entry point is a page that the user gets to see when they initially load the page
 * Not all pages are entry points.
 * @param checkCareAPIResult ds360 API result
 * @param previousStage number of previous stage
 * @param orderStatus orderStatus API result
 * @param state complete state object
 * @param debugStateOverride stage override for debugging
 * @returns {number} STAGE
 */
function checkCareStageHelper(checkCareAPIResult, previousStage, orderStatus, state, debugStateOverride){

    if( DEBUG ) console.log( "#########################################################################################");
    if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper ");
    if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previousStage: " + previousStage );
    if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / orderStatus: " + orderStatus );
    if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state: " + state );
    if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / debugStateOverride: " + debugStateOverride );
    if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / checkCareAPIResult: ");
    if( DEBUG ) console.log( checkCareAPIResult );
    const proposalMoment = moment(checkCareAPIResult.proposalDate);
    const momentDiff = getDaysUntilAppointment(proposalMoment);

    // HB APP: leite zu Stage INTERNET_PROBLEMS
    if(false && momentDiff <= -10){
        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / momentDiff <= -10 -> STAGES.INTERNET_PROBLEMS");
        return STAGES.INTERNET_PROBLEMS;
    }

    // HB APP: appointment day (already) reached?
    if(false && momentDiff <= 0){

        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / momentDiff <= 0");

        //Today is the day of the appointment!
        switch(previousStage){
            case STAGES.APPOINTMENT_DAY:
                if(orderStatus && orderStatus.available === true){
                    //User has hardware, show the router setup
                    return STAGES.ROUTER_SETUP;
                }
                //User has no hardware. Go straight to success
                return STAGES.SUCCESS;
            case STAGES.ROUTER_SETUP:
                return STAGES.SUCCESS;
            default:
                return STAGES.APPOINTMENT_DAY;
        }
    }

    // set STAGE according to customerStatus
    switch(checkCareAPIResult.customerStatus){

        /**
         * "failed" is default customer status when user enters CC process
         */
        case "failed":

            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / customerStatus = failed");

            switch(previousStage) {

                /**
                 * STAGES.LOADING - identify next stage after STAGES.LOADING
                 */
                case STAGES.LOADING:
                    if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.LOADING -> nextStage = STAGES.WELCOME");
                    return STAGES.WELCOME;


                /** **********************************************************************************************
                 *
                 * STAGES.WELCOME
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.WELCOME - identify next stage after STAGES.WELCOME
                     */
                    case STAGES.WELCOME:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.WELCOME -> nextStage = ?");

                        // if line/service is working: go to "STAGES.INSTALLED"
                        if( state.selectedOption == "working" ) {
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == working -> nextStage = STAGES.INSTALLED");
                            return STAGES.INSTALLED;
                        }

                        // if customer still has problems: go into TAM-specific processes
                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == notWorking -> nextStage = ? (depending on TAM)");
                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / switch(checkCareAPIResult.RESULT_CODE) " + checkCareAPIResult.RESULT_CODE );
                        switch( parseInt( checkCareAPIResult.RESULT_CODE ) ) {

                            case 6000:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6000_ENTRY");
                                return STAGES.TAM6000_ENTRY;
                            case 6001:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6001_ENTRY");
                                return STAGES.TAM6001_ENTRY;
                            case 6002:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6002_ENTRY");
                                return STAGES.TAM6002_ENTRY;
                            case 6003:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6003_ENTRY");
                                return STAGES.TAM6003_ENTRY;
                            case 6004:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6004_CALLBACK");
                                return STAGES.TAM6004_CALLBACK;
                            case 6005:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6005_CALLBACK");
                                return STAGES.TAM6005_CALLBACK;
                            case 6006:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6006_CALLBACK");
                                return STAGES.TAM6006_CALLBACK;
                            case 6007:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6007_CALLBACK");
                                return STAGES.TAM6007_CALLBACK;
                            case 6008:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6008_CALLBACK");
                                return STAGES.TAM6008_CALLBACK;
                            case 6009:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6009_CALLBACK");
                                return STAGES.TAM6009_CALLBACK;
                            case 6010:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6010_CALLBACK");
                                return STAGES.TAM6010_CALLBACK;
                            case 6011:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6011_CALLBACK");
                                return STAGES.TAM6011_CALLBACK;
                            case 6013:
                                if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6013_CALLBACK");
                                return STAGES.TAM6013_CALLBACK;

                        }


                /** **********************************************************************************************
                 *
                 * TAM6000 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6000_ENTRY - identify next stage after STAGES.TAM6000_ENTRY
                     */
                    case STAGES.TAM6000_ENTRY:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6000_ENTRY -> nextStage = ?");

                        // if customer has cancelled
                        if( state.selectedOption == "cancel" ) {
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == cancelled -> nextStage = STAGES.TAM6000_CANCELLED");
                            return STAGES.TAM6000_CANCELLED;
                        }

                        // user wants new appointment -> go to new intermediate stage
                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6000_ENTRY_CALENDAR");
                        return STAGES.TAM6000_ENTRY_CALENDAR;

                    /**
                     * STAGES.TAM6003_ENTRY_CALENDAR - identify next stage after STAGES.TAM6003_ENTRY_CALENDAR
                     */
                    case STAGES.TAM6000_ENTRY_CALENDAR:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6000_ENTRY_CALENDAR -> nextStage = ?");

                        // user wants new appointment
                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6000_APPOINTMENT_SELECT_CALENDAR");
                        return STAGES.TAM6000_APPOINTMENT_SELECT_CALENDAR;

                    /**
                     * STAGES.TAM6000_APPOINTMENT_SELECT_CALENDAR - identify next stage after STAGES.TAM6000_APPOINTMENT_SELECT_CALENDAR
                     */
                    case STAGES.TAM6000_APPOINTMENT_SELECT_CALENDAR:

                        // verify appointment screen
                        return STAGES.TAM6000_APPOINTMENT_SELECT_VERIFY;

                    /**
                     * STAGES.TAM6000_APPOINTMENT_SELECT_VERIFY - identify next stage after STAGES.TAM6000_APPOINTMENT_SELECT_VERIFY
                     */
                    case STAGES.TAM6000_APPOINTMENT_SELECT_VERIFY:

                        // confirm appointment screen
                        return STAGES.TAM6000_APPOINTMENT_SELECT_CONFIRM;


                /** **********************************************************************************************
                 *
                 * TAM6001 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6001_ENTRY - identify next stage after STAGES.TAM6001_ENTRY
                     */
                    case STAGES.TAM6001_ENTRY:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6001_ENTRY -> nextStage = ?");

                        // user wants new appointment
                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6001_APPOINTMENT_SELECT_CALENDAR");
                        return STAGES.TAM6001_APPOINTMENT_SELECT_CALENDAR;

                    /**
                     * STAGES.TAM6001_APPOINTMENT_SELECT_CALENDAR - identify next stage after STAGES.TAM6001_APPOINTMENT_SELECT_CALENDAR
                     */
                    case STAGES.TAM6001_APPOINTMENT_SELECT_CALENDAR:

                        // verify appointment screen
                        return STAGES.TAM6001_APPOINTMENT_SELECT_VERIFY;

                    /**
                     * STAGES.TAM6001_APPOINTMENT_SELECT_VERIFY - identify next stage after STAGES.TAM6001_APPOINTMENT_SELECT_VERIFY
                     */
                    case STAGES.TAM6001_APPOINTMENT_SELECT_VERIFY:

                        // confirm appointment screen
                        return STAGES.TAM6001_APPOINTMENT_SELECT_CONFIRM;


                /** **********************************************************************************************
                 *
                 * TAM6002 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6002_ENTRY - identify next stage after STAGES.TAM6002_ENTRY
                     */
                    case STAGES.TAM6002_ENTRY:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6002_ENTRY -> nextStage = ?");

                        // customer did not know about APL
                        if( state.selectedOption == "didNotKnow" ) {
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == didNotKnow -> nextStage = STAGES.TAM6002_APL01");
                            return STAGES.TAM6002_APL01;
                        }

                        // customer data is correct -> user wants new appointment
                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6002_APPOINTMENT_SELECT_CALENDAR");
                        return STAGES.TAM6002_ENTRY_CALENDAR;

                    /**
                     * STAGES.TAM6002_ENTRY_CALENDAR - identify next stage after STAGES.TAM6002_ENTRY_CALENDAR
                     */
                    case STAGES.TAM6002_ENTRY_CALENDAR:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6002_ENTRY_CALENDAR -> nextStage = ?");

                        // user wants new appointment
                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6002_APPOINTMENT_SELECT_CALENDAR");
                        return STAGES.TAM6002_APPOINTMENT_SELECT_CALENDAR;

                    /**
                     * STAGES.TAM6002_APL01 - identify next stage after STAGES.TAM6002_APL01
                     */
                    case STAGES.TAM6002_APL01:

                        // APL02
                        return STAGES.TAM6002_APL02;

                    /**
                     * STAGES.TAM6002_APL02 - identify next stage after STAGES.TAM6002_APL02
                     */
                    case STAGES.TAM6002_APL02:

                        // APL03
                        return STAGES.TAM6002_APL03;

                    /**
                     * STAGES.TAM6002_APL03 - identify next stage after STAGES.TAM6002_APL03
                     */
                    case STAGES.TAM6002_APL03:

                        // APL04 - ENTRY_CALENDAR
                        return STAGES.TAM6002_APL04_ENTRY_CALENDAR;

                    /**
                     * STAGES.TAM6002_APL04_ENTRY_CALENDAR - identify next stage after STAGES.TAM6002_APL04_ENTRY_CALENDAR
                     */
                    case STAGES.TAM6002_APL04_ENTRY_CALENDAR:

                        // Select Appointment
                        return STAGES.TAM6002_APPOINTMENT_SELECT_CALENDAR;

                    /**
                     * STAGES.TAM6002_APPOINTMENT_SELECT_CALENDAR - identify next stage after STAGES.TAM6002_APPOINTMENT_SELECT_CALENDAR
                     */
                    case STAGES.TAM6002_APPOINTMENT_SELECT_CALENDAR:

                        // verify appointment screen
                        return STAGES.TAM6002_APPOINTMENT_SELECT_VERIFY;

                    /**
                     * STAGES.TAM6002_APPOINTMENT_SELECT_VERIFY - identify next stage after STAGES.TAM6002_APPOINTMENT_SELECT_VERIFY
                     */
                    case STAGES.TAM6002_APPOINTMENT_SELECT_VERIFY:

                        // confirm appointment screen
                        return STAGES.TAM6002_APPOINTMENT_SELECT_CONFIRM;

                /** **********************************************************************************************
                 *
                 * TAM6003 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6003_ENTRY - identify next stage after STAGES.TAM6003_ENTRY
                     */
                    case STAGES.TAM6003_ENTRY:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6003_ENTRY -> nextStage = ?");

                        // if customer data is not correct => Callback
                        if( state.selectedOption == "address_check_not_ok" ) {
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == no -> nextStage = STAGES.TAM6003_CALLBACK");
                            return STAGES.TAM6003_CALLBACK;
                        }

                        // customer data is correct -> user wants new appointment -> go to intermediate screen TAM6003_ENTRY_CALENDAR
                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == yes -> nextStage = STAGES.TAM6003_ENTRY_CALENDAR");
                        return STAGES.TAM6003_ENTRY_CALENDAR;

                    /**
                     * STAGES.TAM6003_CALLBACK - identify next stage after STAGES.TAM6003_CALLBACK
                     */
                    case STAGES.TAM6003_CALLBACK:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6003_CALLBACK -> nextStage = ?");

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6003_CALLBACK_CONFIRM");
                        return STAGES.TAM6003_CALLBACK_CONFIRM;

                    /**
                     * STAGES.TAM6003_ENTRY_CALENDAR - identify next stage after STAGES.TAM6003_ENTRY_CALENDAR
                     */
                    case STAGES.TAM6003_ENTRY_CALENDAR:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6003_ENTRY_CALENDAR -> nextStage = ?");

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6003_APPOINTMENT_SELECT_CALENDAR");
                        return STAGES.TAM6003_APPOINTMENT_SELECT_CALENDAR;

                    /**
                     * STAGES.TAM6003_APPOINTMENT_SELECT_CALENDAR - identify next stage after STAGES.TAM6003_APPOINTMENT_SELECT_CALENDAR
                     */
                    case STAGES.TAM6003_APPOINTMENT_SELECT_CALENDAR:

                        // verify appointment screen
                        return STAGES.TAM6003_APPOINTMENT_SELECT_VERIFY;

                    /**
                     * STAGES.TAM6003_APPOINTMENT_SELECT_VERIFY - identify next stage after STAGES.TAM6003_APPOINTMENT_SELECT_VERIFY
                     */
                    case STAGES.TAM6003_APPOINTMENT_SELECT_VERIFY:

                        // confirm appointment screen
                        return STAGES.TAM6003_APPOINTMENT_SELECT_CONFIRM;

                /** **********************************************************************************************
                 *
                 * TAM6004 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6004_CALLBACK - identify next stage after STAGES.TAM6004_CALLBACK
                     */
                    case STAGES.TAM6004_CALLBACK:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6004_CALLBACK -> nextStage = ?");

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6004_CALLBACK_CONFIRM");
                        return STAGES.TAM6004_CALLBACK_CONFIRM;


                /** **********************************************************************************************
                 *
                 * TAM6005 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6005_CALLBACK - identify next stage after STAGES.TAM6005_CALLBACK
                     */
                    case STAGES.TAM6005_CALLBACK:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6005_CALLBACK -> nextStage = ?");

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6005_CALLBACK_CONFIRM");
                        return STAGES.TAM6005_CALLBACK_CONFIRM;


                /** **********************************************************************************************
                 *
                 * TAM6006 Stages - keine weiteren Stages/Screens nach dem Entry
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6006_CALLBACK - identify next stage after STAGES.TAM6006_CALLBACK
                     */
                    case STAGES.TAM6006_CALLBACK:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6006_CALLBACK -> nextStage = ?");

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6006_CALLBACK_CONFIRM");
                        return STAGES.TAM6006_CALLBACK_CONFIRM;


                /** **********************************************************************************************
                 *
                 * TAM6007 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6007_CALLBACK - identify next stage after STAGES.TAM6007_CALLBACK
                     */
                    case STAGES.TAM6007_CALLBACK:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6007_CALLBACK -> nextStage = ?");

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6007_CALLBACK_CONFIRM");
                        return STAGES.TAM6007_CALLBACK_CONFIRM;


                /** **********************************************************************************************
                 *
                 * TAM6008 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6008_CALLBACK - identify next stage after STAGES.TAM6008_CALLBACK
                     */
                    case STAGES.TAM6008_CALLBACK:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6008_CALLBACK -> nextStage = ?");

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6008_CALLBACK_CONFIRM");
                        return STAGES.TAM6008_CALLBACK_CONFIRM;


                /** **********************************************************************************************
                 *
                 * TAM6009 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6009_CALLBACK - identify next stage after STAGES.TAM6009_CALLBACK
                     */
                    case STAGES.TAM6009_CALLBACK:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6009_CALLBACK -> nextStage = ?");

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6009_CALLBACK_CONFIRM");
                        return STAGES.TAM6009_CALLBACK_CONFIRM;


                /** **********************************************************************************************
                 *
                 * TAM6010 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6010_CALLBACK - identify next stage after STAGES.TAM6010_CALLBACK
                     */
                    case STAGES.TAM6010_CALLBACK:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6010_CALLBACK -> nextStage = ?");

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6010_CALLBACK_CONFIRM");
                        return STAGES.TAM6010_CALLBACK_CONFIRM;


                /** **********************************************************************************************
                 *
                 * TAM6011 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6011_CALLBACK - identify next stage after STAGES.TAM6011_CALLBACK
                     */
                    case STAGES.TAM6011_CALLBACK:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6011_CALLBACK -> nextStage = ?");

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6011_CALLBACK_CONFIRM");
                        return STAGES.TAM6011_CALLBACK_CONFIRM;


                /** **********************************************************************************************
                 *
                 * TAM6013 Stages
                 *
                 *********************************************************************************************** */

                    /**
                     * STAGES.TAM6013_CALLBACK - identify next stage after STAGES.TAM6013_CALLBACK
                     */
                    case STAGES.TAM6013_CALLBACK:

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.TAM6013_CALLBACK -> nextStage = ?");

                        if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / state.selectedOption == continue -> nextStage = STAGES.TAM6013_CALLBACK_CONFIRM");
                        return STAGES.TAM6013_CALLBACK_CONFIRM;


            }

            // default: return STAGE WELCOME
            return STAGES.WELCOME;


        /**
         * "installed" - Customer confirmed that everything is working
         */
        case "installed":

            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / customerStatus = installed");

            switch(previousStage) {

                /**
                 * STAGES.LOADING - identify next stage after STAGES.LOADING
                 */
                case STAGES.LOADING:
                    if (DEBUG) console.log("FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.LOADING -> nextStage = STAGES.INSTALLED");
                    return STAGES.INSTALLED;

            }

            // default: return STAGE WELCOME
            return STAGES.WELCOME;


        /**
         * "cancelled" - Customer cancelled - Customer getting redirected to Retourenportal
         */
        case "cancelled":

            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / customerStatus = cancelled");

            switch(previousStage) {

                /**
                 * STAGES.LOADING - identify next stage after STAGES.LOADING
                 */
                case STAGES.LOADING:
                    if (DEBUG) console.log("FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.LOADING -> nextStage = STAGES.TAM6000_CANCELLED");
                    return STAGES.TAM6000_CANCELLED;

            }

            // default: return STAGE WELCOME
            return STAGES.WELCOME;


        /**
         * "selected" - Customer booked a new appointment
         */
        case "selected":

            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / customerStatus = installed");

            switch(previousStage) {

                /**
                 * STAGES.LOADING - identify next stage after STAGES.LOADING
                 */
                case STAGES.LOADING:
                    if (DEBUG) console.log("FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.LOADING -> nextStage = STAGES.TAM60XX_APPOINTMENT_SELECT_CONFIRM");

                    // go to TAM-specific CONFIRM page
                    if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / switch(checkCareAPIResult.RESULT_CODE) " + checkCareAPIResult.RESULT_CODE );
                    switch( parseInt( checkCareAPIResult.RESULT_CODE ) ) {

                        case 6000:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6000_APPOINTMENT_SELECT_CONFIRM");
                            return STAGES.TAM6000_APPOINTMENT_SELECT_CONFIRM;
                        case 6001:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6001_APPOINTMENT_SELECT_CONFIRM");
                            return STAGES.TAM6001_APPOINTMENT_SELECT_CONFIRM;
                        case 6002:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6002_APPOINTMENT_SELECT_CONFIRM");
                            return STAGES.TAM6002_APPOINTMENT_SELECT_CONFIRM;
                        case 6003:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6003_APPOINTMENT_SELECT_CONFIRM");
                            return STAGES.TAM6003_APPOINTMENT_SELECT_CONFIRM;

                    }

            }

            // default: return STAGE WELCOME
            return STAGES.WELCOME;


        /**
         * "clarification" - Customer booked a Callback
         */
        case "clarification":

            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / customerStatus = clarification");

            switch(previousStage) {

                /**
                 * STAGES.LOADING - identify next stage after STAGES.LOADING
                 */
                case STAGES.LOADING:
                    if (DEBUG) console.log("FNX: checkCareStageHelper.js / checkCareStageHelper / previous stage = STAGES.LOADING -> nextStage = STAGES.INSTALLED");

                    // go to TAM-specific CONFIRM page
                    if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / switch(checkCareAPIResult.RESULT_CODE) " + checkCareAPIResult.RESULT_CODE );
                    switch( parseInt( checkCareAPIResult.RESULT_CODE ) ) {

                        case 6003:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6003_CALLBACK_CONFIRM");
                            return STAGES.TAM6003_CALLBACK_CONFIRM;
                        case 6004:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6004_CALLBACK_CONFIRM");
                            return STAGES.TAM6004_CALLBACK_CONFIRM;
                        case 6005:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6005_CALLBACK_CONFIRM");
                            return STAGES.TAM6005_CALLBACK_CONFIRM;
                        case 6006:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6006_CALLBACK_CONFIRM");
                            return STAGES.TAM6006_CALLBACK_CONFIRM;
                        case 6007:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6007_CALLBACK_CONFIRM");
                            return STAGES.TAM6007_CALLBACK_CONFIRM;
                        case 6008:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6008_CALLBACK_CONFIRM");
                            return STAGES.TAM6008_CALLBACK_CONFIRM;
                        case 6009:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6009_CALLBACK_CONFIRM");
                            return STAGES.TAM6009_CALLBACK_CONFIRM;
                        case 6010:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6010_CALLBACK_CONFIRM");
                            return STAGES.TAM6010_CALLBACK_CONFIRM;
                        case 6011:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6011_CALLBACK_CONFIRM");
                            return STAGES.TAM6011_CALLBACK_CONFIRM;
                        case 6013:
                            if( DEBUG ) console.log( "FNX: checkCareStageHelper.js / checkCareStageHelper / -> nextStage = STAGES.TAM6013_CALLBACK_CONFIRM");
                            return STAGES.TAM6013_CALLBACK_CONFIRM;

                    }

                    return STAGES.WELCOME;

            }

            // default: return STAGE WELCOME
            return STAGES.WELCOME;

        // status not defined here? -> throw error
        default:
            throw new Error("CC API invalid customerStatus "+checkCareAPIResult.customerStatus);

    }
}

export default checkCareStageHelper
export {getDaysUntilAppointment}
